import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import AdCaller from 'helpers/ads/adCaller';
import ImageV2 from 'components_v2/common/ImageV2';
import { dateToStringWithFormatTopic } from 'utils/dateUtils';
import _get from 'lodash.get';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import s from './AboutTopic.scss';
import CandidateInfoDataTable, {
  candidatePersonalTableMapping,
  candidatePoliticalMapping,
} from '../../../../../components_v2/common/CandidateShowWrapper/CandidateInfoDataTable';
import CandidateStatus from '../../../../../components_v2/common/CandidateShowWrapper/CandidateStatus';
import AdrData from '../../../../../components_v2/common/CandidateShowWrapper/AdrData';

function AboutTopic(props) {
  const {
    topic,
    ads,
    isPrime,
    gaCategory,
    selectedTab,
    loadAllAds,
    bio,
    tabSelected,
  } = props;

  const [readMoreButton, setReadMoreButton] = useState(true);
  const [showReadMore, setShowReadMore] = useState(false);
  const searchData = _get(topic, 'medDocRef[0].medleyDoc', undefined);
  const professionData =
    searchData &&
    searchData.celebrityRole &&
    searchData.celebrityRole.split(',');
  const entmsid =
    topic &&
    topic.relatedCmsEntities &&
    Array.isArray(topic.relatedCmsEntities) &&
    topic.relatedCmsEntities.length > 0
      ? topic?.relatedCmsEntities[0]?.msId
      : '';
  const msid = topic?.thumbnail?.defaultImageMsid || entmsid;
  const imageSize =
    topic?.thumbnail?.fileInfo &&
    topic?.thumbnail?.fileInfo?.sizeInBytes &&
    topic?.thumbnail?.fileInfo?.sizeInBytes !== -1
      ? topic?.thumbnail?.fileInfo?.sizeInBytes
      : '';
  const ImageElement = ImageV2;
  // eslint-disable-next-line prefer-const
  let [tabBio, updatedAt] = bio || [];
  // if (tabSelected === 'awards') {
  tabBio = tabBio?.replace(/\{celebname\}/g, topic?.title);
  // }

  const profileType = searchData && searchData.profession;
  const changeAboutDataState = e => {
    e.preventDefault();
    if (readMoreButton)
      sendGaThroughProps({
        data: {
          gaCategory,
          gaAction: `Search_Result-${selectedTab}`,
          gaLabel: `Bio-Read_More-${topic.title}`,
        },
      });
    else {
      sendGaThroughProps({
        data: {
          gaCategory,
          gaAction: `Search_Result-${selectedTab}`,
          gaLabel: `Bio-Read_Less-${topic.title}`,
        },
      });
      if (typeof window !== 'undefined') {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      }
    }
    setReadMoreButton(!readMoreButton);
  };
  const aboutInfo = tabSelected?.toLowerCase() === 'all' ? topic.body : tabBio;
  useEffect(
    () => {
      if (typeof loadAllAds === 'function') {
        props.loadAllAds();
      }
      if (typeof document !== 'undefined') {
        const readMoreCtn = document.getElementById('read-more-div');
        if (readMoreCtn) {
          const showReadMoreVal =
            document.getElementById('read-more-div').clientHeight > 84;
          if (showReadMore !== showReadMoreVal) {
            setShowReadMore(showReadMoreVal);
          }
        }
      }
    },
    [tabSelected],
  );
  if (topic && !topic.uid) return null;

  return (
    <React.Fragment>
      <div className={s.author_wrapper}>
        <div className={s.left_place}>
          <div
            className={`${s.authorTop} ${profileType ? s.authorTag : ''}`}
            data-ua-type="1"
            data-sp-pd-click="stpPgtnAndPrvntDefault(event)"
            onClick={event => {
              window.stpPgtnAndPrvntDefault(event);
            }}
          >
            <div className={s.right_block}>
              <div className={s.author_image}>
                <ImageElement
                  imgsize={imageSize}
                  width="168"
                  msid={msid}
                  placeHolderSrc="https://static.toiimg.com/photo/87458172.cms"
                  alt="Logo"
                />
              </div>
            </div>
            <div className={s.autorInfo}>
              {profileType && (
                <div className={s.smallheading}>{profileType}</div>
              )}

              <h1 className={s.authorname}>{topic.title || ''}</h1>
              <div className={s.specialites}>
                {professionData &&
                  professionData.map(data => <span>{data}</span>)}
              </div>
              {searchData &&
                searchData.dateOfBirth &&
                searchData.placeOfBirth && (
                  <div className={s.birthdetails}>
                    Born -{' '}
                    {dateToStringWithFormatTopic(
                      parseInt(searchData.dateOfBirth, 10),
                      ' MMMM DD, YYYY',
                    )}{' '}
                    in {searchData.placeOfBirth}
                  </div>
                )}
              {topic?.meta &&
                Array.isArray(topic.meta) &&
                topic.meta.length > 0 && (
                  <div className={s.resultStatus}>
                    <CandidateStatus candidateList={topic.meta} />
                  </div>
                )}
            </div>
          </div>
          <div
            className={`${s.about} ${readMoreButton ? `` : s.readmoreextend}`}
          >
            <>
              {aboutInfo && (
                <div
                  className={s.aboutIn}
                  data-ua-type="2"
                  data-sp-pd-click="stpPgtn(event)"
                  onClick={event => {
                    window.stpPgtn(event);
                  }}
                >
                  <div id="read-more-div">
                    <span dangerouslySetInnerHTML={{ __html: aboutInfo }} />
                  </div>
                </div>
              )}

              {tabSelected !== 'all' &&
                updatedAt && (
                  <div
                    className="updateLabel"
                    data-ua-type="1"
                    data-sp-pd-click="stpPgtnAndPrvntDefault(event)"
                    onClick={event => {
                      window.stpPgtnAndPrvntDefault(event);
                    }}
                  >
                    <span>{updatedAt}</span>
                  </div>
                )}

              {aboutInfo &&
                showReadMore && (
                  <a className={s.read_more} onClick={changeAboutDataState}>
                    {readMoreButton ? `Read More` : `Read Less`}
                  </a>
                )}
            </>
          </div>
          {topic?.lang && (
            <div className={s.boxWrap}>
              <CandidateInfoDataTable
                data={topic?.lang}
                title="Political Information"
                tableMapping={candidatePoliticalMapping}
              />
            </div>
          )}
          {topic?.meta &&
            Array.isArray(topic.meta) &&
            topic.meta.length > 0 &&
            topic.meta[0] &&
            topic.meta[0]?.regInfo &&
            topic.meta[0]?.regInfo?.all && (
              <>
                <div className={s.boxWrap}>
                  <CandidateInfoDataTable
                    data={topic.meta[0]?.regInfo.all}
                    title="Personal Information"
                    tableMapping={candidatePersonalTableMapping}
                  />
                </div>
                <div className={s.boxWrap}>
                  <AdrData />
                </div>
              </>
            )}
        </div>
        {!isPrime &&
          ads && (
            <div className={s.ad_wrapper_tab}>
              <div className="paisa-wrapper">
                <div className={s.mrec_banner}>
                  <AdCaller data={{ ...ads, name: 'mrec' }} key={ads.divId} />
                </div>
              </div>
            </div>
          )}
      </div>
    </React.Fragment>
  );
}

const mapStateToProps = state => ({
  topic: _get(state, 'topic.topic', {}),
});

export default connect(mapStateToProps)(AboutTopic);
